import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientService } from '@morningstar/shared/services/client';
import { AngularMaterialModule } from 'apps/wsg/src/app/angular-material.module';
import { ClientsComponent } from './clients.component';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [
    ClientsComponent
  ],
  exports: [
    ClientsComponent
  ],
  providers: [
    ClientService
  ]
})
export class ClientsModule { }
